import { FCX, getFormattedThousand, Tooltip } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IConversationTheme } from "@core/apiHooks/useSocialThemes";
import './ConversationThemes.scss';

const FOODIE_INDEX_TOOLTIP_ID = 'foodie-index-info';

const ConversationThemes: FCX<{
    data: IConversationTheme[];
    selectedId: number | null;
    onSelect: (id: number) => void;
    isInfluencersView?: boolean;
}> = ({ data, selectedId, onSelect, isInfluencersView = false }) => {
    return (
        <div className="ConversationThemes" data-testid="blockConversationThemes">
            <div className="ConversationThemes__title">
                {isInfluencersView ? (
                    <span>TOP CONVERSATION THEMES</span>
                ) : (
                    <>
                        <span>TOP THEMES</span>
                        <span
                            className="ConversationThemes__title-right"
                            data-tooltip-id={FOODIE_INDEX_TOOLTIP_ID}
                        >
                            <span>FOODIE<br/>INDEX</span>
                        </span>
                        <Tooltip
                            id={FOODIE_INDEX_TOOLTIP_ID}
                            place="top"
                            className="ConversationThemes__tooltip"
                        >
                            1-100 score reflecting share of engagement with past-month social posts from Datassential's Foodie Panel;<br/>100 = most engagement
                        </Tooltip>
                    </>
                )}
            </div>
            <div className="ConversationThemes__list">
                {data.map((theme, index) => (
                    <div
                        key={theme.id}
                        className={cn(
                            "ConversationThemes__item",
                            selectedId === theme.id && "is-active",
                        )}
                        onClick={() => onSelect(theme.id)}
                        data-testid={`blockConversationThemesItem-${index}`}
                    >
                        <span className="ConversationThemes__item-index">{index + 1}.</span>
                        <span className="ConversationThemes__item-name">{theme.name}</span>
                        <span className="ConversationThemes__item-count">
                            {getFormattedThousand(theme.score)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ConversationThemes;
